import { render, staticRenderFns } from "./CovertConfirm.vue?vue&type=template&id=fb8a350a&scoped=true&"
import script from "./CovertConfirm.vue?vue&type=script&lang=js&"
export * from "./CovertConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb8a350a",
  null
  
)

export default component.exports